// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingRail-module__rail___mbHLy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 84px;
  flex-shrink: 0;
  padding: 10px 8px;
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  height: 100%;
}

.BookingRail-module__start___t8HJz {
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  font-weight: 600;
  color: #18181b;
}

.BookingRail-module__block___tGwUs {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-top: 4px;
  padding: 2px 6px;
  border-left: 3px solid;
  border-radius: 4px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  font-weight: 600;
}

.BookingRail-module__end___PyATi {
  margin-top: 4px;
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  color: #71717a;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/BookingRail/BookingRail.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,uCAAA;EACA,eAAA;EACA,cAAA;AACF","sourcesContent":[".rail {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 84px;\n  flex-shrink: 0;\n  padding: 10px 8px;\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  height: 100%;\n}\n\n.start {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.block {\n  display: flex;\n  align-items: flex-start;\n  width: 100%;\n  margin-top: 4px;\n  padding: 2px 6px;\n  border-left: 3px solid;\n  border-radius: 4px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.end {\n  margin-top: 4px;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  color: #71717a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rail": `BookingRail-module__rail___mbHLy`,
	"start": `BookingRail-module__start___t8HJz`,
	"block": `BookingRail-module__block___tGwUs`,
	"end": `BookingRail-module__end___PyATi`
};
module.exports = ___CSS_LOADER_EXPORT___;
